import React from "react";
import { IconButton, useCopyToClipboard } from "@SeemplicityDev/shared";

interface CopyCodeButtonProps {
  preRef: React.RefObject<HTMLPreElement>;
}

const CopyCodeButton: React.FC<CopyCodeButtonProps> = ({ preRef }) => {
  const { copyLabel, copyText } = useCopyToClipboard();

  const handleCopy = () => {
    const text = preRef.current?.textContent || "";
    copyText(text);
  };

  return (
    <div className="code-copy-btn">
      <IconButton
        data-testid="copy-code-btn"
        isIcon="seem-icon-copy"
        buttonStyle="secondary"
        size="xxs"
        isGhost
        onClick={handleCopy}
        withTooltip={{ content: copyLabel }}
      />
    </div>
  );
};

export default CopyCodeButton;
